import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTrash,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import * as fromActions from 'store/actions/lms-profiles.action'
import DiscontinuedButton from 'design-system/button'
import { ButtonVariant, ButtonSizes } from 'design-system/button/src/Button'

interface IProfile {
  id: number
  count: number
  hasLearningPath: boolean
}
const DeleteProfileButton: React.FC<IProfile> = ({
  id: profileId,
  count,
  hasLearningPath,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [show, setShow] = useState(false)
  const generalDisabled = profileId === 1
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleDeleteProfile = () => {
    handleClose()
    dispatch({
      type: fromActions.LMS_PROFILES_DELETE_PROFILE,
      payload: profileId,
    })
  }

  const warningSummary = hasLearningPath ? 'warningSummaryLp' : 'warningSummary'
  const warningDescription = hasLearningPath
    ? 'warningDescriptionLp'
    : 'warningDescription'

  return (
    <>
      <Button onClick={handleShow} disabled={generalDisabled}>
        <FontAwesomeIcon icon={faTrash} />
      </Button>
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton className="bg-light border-bottom-0">
          <Modal.Title>
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              className="mr-2 text-warning"
            />
            <span>
              {t('configuration.lmsProfiles.deleteProfile.modal.title')}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <b>
              {t(
                `configuration.lmsProfiles.deleteProfile.modal.${warningSummary}`,
                { count }
              )}
            </b>
            &nbsp;
            {t(
              `configuration.lmsProfiles.deleteProfile.modal.${warningDescription}`
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <DiscontinuedButton
            variant={ButtonVariant.Secondary}
            size={ButtonSizes.Small}
            onClick={handleClose}
          >
            {t('commons.buttons.cancel')}
          </DiscontinuedButton>
          <DiscontinuedButton
            size={ButtonSizes.Small}
            onClick={handleDeleteProfile}
            variant={ButtonVariant.Danger}
          >
            {t('commons.buttons.accept')}
          </DiscontinuedButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default DeleteProfileButton
